import React from "react";
import "./About.css";
import { motion } from "framer-motion";
import { FaRocket, FaEye } from "react-icons/fa";

const MissionVision = () => {
  return (
    <section className="backdiv">

      <h2  className="main-title">Our Mission & Vision</h2>

      <div className="mv-container">

        {/* MISSION */}
        <motion.div
          className="mv-card"
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <div className="mv-icon">
            <FaRocket />
          </div>

          <h3 > Mission</h3>

          <p  className="main-text-white">
           
To bridge the gap between business ambition and technological possibility.

To design intelligent solutions that solve real-world business challenges.

To build long-term partnerships founded on trust, transparency, and excellence.

To continuously innovate, adapt, and empower businesses to thrive in a rapidly changing world.
          </p>

        </motion.div>

        <motion.div
          className="mv-img-card"
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
        >
          <img className="cover-img"
            src="./mission.webp"
            alt="Company"
            loading="lazy"
          />
        </motion.div>

      </div>
       <div className="mv-container2">

    
        <motion.div
          className="mv-img-card"
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
            <img className="cover-img"
            src="./vision.webp"
            alt="Company"
            loading="lazy"
          />

   
        </motion.div>

        {/* VISION */}
        <motion.div
          className="mv-card"
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
        >
          <div className="mv-icon">
            <FaEye />
          </div>

          <h3>Vision</h3>

          <p className="main-text-white">
           To become a globally respected technology company that empowers businesses through intelligent innovation, transformative digital experiences, and future-ready solutions.

We envision a future where organizations of every size have access to technology that inspires growth, builds trust, and creates lasting impact.
          </p>

        
        </motion.div>

      </div>

    </section>
  );
};

export default MissionVision;